import { Box, Flex } from '@chakra-ui/react';
import { ViewFile } from '@/components/ats';

export const DocumentList = ({ documents, onRemove }) => {
  if (documents.length === 0) return null;

  return (
    <Flex flexWrap="wrap" gap="12px" mb="8px">
      {documents.map((doc, docIndex) => {
        const isFullWidth =
          documents.length % 2 !== 0 && docIndex === documents.length - 1;

        return (
          <Box key={docIndex} flex="1 1 calc(50% - 6px)" minW="calc(50% - 6px)">
            <ViewFile
              primaryColor="secondary-700"
              file={doc}
              showIcon
              showDelete
              showPreview={!!doc.url}
              hideTextReference
              showDownload={!!doc.url}
              handleDelete={() => onRemove(docIndex)}
              containerProps={{
                p: '12px 16px',
                borderRadius: '8px',
              }}
              maxW={isFullWidth ? '80%' : '80px'}
            />
          </Box>
        );
      })}
    </Flex>
  );
};
